module.exports = __webpack_public_path__ + "static/media/error-de-localizacion-background.e0a1d383.jpg";